<template>
  <!-- The wrapper span carries the title too: Bootstrap sets pointer-events: none on
       disabled buttons, so the button's own tooltip never shows while disabled. -->
  <span class="copy-ai-prompt-wrap" :class="{ 'is-disabled': disabled }" :title="title">
    <button type="button" class="btn btn-sm" style="min-width: 160px;"
            :class="error ? 'btn-danger' : (copied ? 'btn-success' : 'btn-outline-primary')"
            :disabled="disabled"
            @click="copy"
            :title="title">
      <span v-if="error"><span class="fas fa-exclamation-triangle me-1"></span> Copy failed</span>
      <span v-else-if="copied"><span class="fas fa-check me-1"></span> Copied</span>
      <span v-else><span class="fas fa-robot me-1"></span> Copy AI Prompt</span>
    </button>
  </span>
</template>

<script>
export default {
  name: 'CopyAiPromptButton',
  props: {
    // The prompt text to copy. Pass a function if you want it computed lazily at click-time.
    prompt: {
      type: [String, Function],
      required: true
    },
    title: {
      type: String,
      default: 'Copy a ready-made prompt to help your AI set up the trading alerts for this Bot easily.'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      copied: false,
      error: false,
      timer: null
    }
  },
  methods: {
    async copy () {
      const text = (typeof this.prompt === 'function') ? this.prompt() : this.prompt
      if (!text) return

      try {
        await navigator.clipboard.writeText(text)
        if (this.timer) clearTimeout(this.timer)
        this.error = false
        this.copied = true
        this.timer = setTimeout(() => { this.copied = false }, 2000)
      } catch (e) {
        console.error('Clipboard write failed:', e)
        if (this.timer) clearTimeout(this.timer)
        this.copied = false
        this.error = true
        this.timer = setTimeout(() => { this.error = false }, 3000)
      }
    }
  },
  beforeUnmount () {
    if (this.timer) clearTimeout(this.timer)
  }
}
</script>

<style scoped>
/* inline-grid: content-sized in normal flow (like the bare button was), but blockified
   to a stretching grid item inside d-grid parents, so the button stays full-width there. */
.copy-ai-prompt-wrap {
  display: inline-grid;
}
.copy-ai-prompt-wrap.is-disabled {
  cursor: not-allowed;
}
</style>
